import { render, staticRenderFns } from "./FreightOptionsModal.vue?vue&type=template&id=310b22d4"
import script from "./FreightOptionsModal.vue?vue&type=script&lang=ts"
export * from "./FreightOptionsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports